module.exports = __webpack_public_path__ + "img/pick3.4a2f90e5.png";